export enum RoleEnum {
  Novice = 'base',
  Dabbler = 'dabbler',
  Soloist = 'soloist',
  Pro = 'pro',
}
